var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlinedStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5388 1.77223C7.70989 1.36238 8.29053 1.36238 8.46162 1.77223L9.92933 5.28815C9.99771 5.45195 10.1478 5.56722 10.3237 5.59102L14.1919 6.11457C14.6254 6.17324 14.7799 6.72089 14.441 6.99744L11.4542 9.43479C11.3065 9.55528 11.2402 9.74923 11.2831 9.9349L12.2381 14.0615C12.3415 14.5083 11.8391 14.8469 11.4637 14.5835L8.28745 12.3542C8.11506 12.2332 7.88535 12.2332 7.71297 12.3542L4.53667 14.5835C4.16132 14.8469 3.65892 14.5083 3.76231 14.0615L4.71718 9.9349C4.76014 9.74923 4.69382 9.55528 4.54617 9.43479L1.55941 6.99744C1.22053 6.72089 1.37502 6.17324 1.80847 6.11457L5.67673 5.59102C5.85262 5.56722 6.00271 5.45195 6.07108 5.28815L7.5388 1.77223Z",
    stroke: "#ABABB1",
    strokeWidth: 1.5,
    strokeMiterlimit: 3.3292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedStar);
export default __webpack_public_path__ + "static/media/outlined-star.78f7d1f38acf7f6d5cbf8c703981b544.svg";
export { ForwardRef as ReactComponent };